import React, { forwardRef } from 'react';
import { Slide, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Avatar, DialogContentText, CircularProgress } from '@mui/material';
import { Warning, Close } from '@mui/icons-material';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmationDialog = ({ open, onClose, onSend, loading }) => {
    return (
        <div>
            <Dialog
                open={open}
                slots={{ transition: Transition }}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth="xs"
                hideBackdrop
            >
                <IconButton
                    sx={{ position: 'absolute', right: 10, top: 10 }}
                    onClick={onClose}
                    disabled={loading}
                >
                    <Close />
                </IconButton>

                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        paddingBottom: 1,
                        gap: 1,
                        bgcolor: 'background.paper',
                    }}
                >
                    <Avatar
                        sx={{
                            width: 50,
                            height: 50,
                            backgroundColor: (theme) => theme.palette.secondary.dark,
                        }}
                    >
                        <Warning sx={{ color: '#fd8d8d', fontSize: 24 }} />
                    </Avatar>
                    Confirm Newsletter
                </DialogTitle>

                <DialogContent
                    sx={{ textAlign: 'center', paddingBottom: 1, bgcolor: 'background.paper' }}
                >
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to send this newsletter?
                    </DialogContentText>
                </DialogContent>

                <DialogActions
                    sx={{ justifyContent: 'center', paddingBottom: 1.5, bgcolor: 'background.paper' }}
                >
                    <Button
                        onClick={onSend}
                        variant="contained"
                        color="primary"
                        disableElevation
                        sx={{ textTransform: 'none' }}
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={24} color="inherit" /> : null}
                    >
                        {loading ? 'Sending...' : 'Yes, Send'}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default ConfirmationDialog
